import type { ResponseWithType, ResultDetailRest, ResultDetail } from './types';

const resultDetailResponse = ({ data }: ResponseWithType<ResultDetailRest>): ResultDetail => {
  return {
    __typename: 'ResultDetail',
    id: data.uniqueCode,
    ...data,
  };
};

export default resultDetailResponse;
